import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";
import Layout from "../../../Components/layout";
import logo from "../../../assets/imgs/logo2.32a2f0e40fc629cb6e51.png";
import MtnZaService from "../../../Utilies/Utilies/MtnZaService";
import SubscribeBtn from "../../../Components/SubscribeBtn/SubscribeBtn";
import btn from "./../../../assets/imgs/Assetbtn.svg";

const MtnzaSignup = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getMarketingParams();
  }, []);

 

  const getMarketingParams = () => {
    const trafficsource = searchParams.get("trafficsource");
    const parameter = searchParams.get("parameter");
    if (trafficsource) {
      localStorage.setItem("trafficsource", trafficsource);
    }
    if (parameter) {
      localStorage.setItem("parameter", parameter);
    }
  };

  const handleSubscribe = async () => {
    setLoading(true);
    try {
      const response = await MtnZaService.subscribe();
      if (response?.data?.url) {
        window.location.href = response.data.url;
      }
    } catch (error) {
      console.error("Subscription error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <> <Layout>
        <img className="servImg" src={logo} alt="" />

     
          
          <div className="desc-text">{t("desc")}</div>
      
       <form
          className=" overflow-hidden w-100"
          onSubmit={(e) => {
            e.preventDefault(); 
            handleSubscribe(); 
          }}
        >
          <button className="btn btn-primary w-50 rounded-pill text-center" onClick={handleSubscribe}>{t("subscribe")}</button>
        </form>
        

        <div className="terms px-3">
          <h6 className="mb-0">{t("TERMS AND CONDITIONS")}:</h6>
          <p className="mb-0">
            {t("by clicking on subscribe, you agree the below terms and conditions")}
          </p>
          <ul style={{textAlign: "left"}}>
            <li>{t("support_contact")}</li>
            <li>
              {t("FURTHER_TERMS")}{" "}
              <Link to="/terms-world-link" target="_blank">
                {t("CLICK_HERE")}
              </Link>{" "}
              {t("PRIVACY_POLICY")}{" "}
              <Link to="/privacy" target="_blank">
                {t("CLICK_HERE")}
              </Link>
            </li>
            <li>{t("unsubCodition")}</li>
            <li>{t("unsubkey")}</li>
            <li>{t("subcost")}</li>
            <li>{t("subscription_end")}</li>
          </ul>
        </div>

       
    
    </Layout>
    </>
   
  );
};

export default MtnzaSignup;
